const reloadPage = () => {
  window.location.reload();
};

export { reloadPage };
